import { Box, type SxProps, type Theme, Typography } from '@mui/material'
import { PriorityBudgetDisplay } from './PriorityBudgetDisplay'
import { type BudgetSummary } from '../../../../models/BudgetSummary'
import { RcnOperationsBudgetDisplay } from './RcnOperationsBudgetDisplay'

interface Props {
  organizationName: string
  budgetSummary: BudgetSummary
  sx?: SxProps<Theme>
}
export const BudgetSummaryPreview = (props: Props): JSX.Element => {
  return <Box sx={props.sx} data-testid='budgetSummaryPreview'>
    <Typography variant='h5' sx={{ textAlign: 'center' }}>
      Exhibit B - RCN Compensation and Contract Costs
    </Typography>

    <Typography variant='h3' sx={{ mt: '1em' }}>
      Budget Overview - {props.organizationName}
    </Typography>

    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        borderBottom: '1px solid var(--grey-300)'
      }}
    >
      <Typography variant='h4'>
        Total Budget Request
      </Typography>

      <Typography variant='h2'>
        {props.budgetSummary.totalBudgetAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
      </Typography>
    </Box>

    <RcnOperationsBudgetDisplay rcnOperationsSummary={props.budgetSummary.rcnOperationsSummary} />

    <PriorityBudgetDisplay
      title='Priority 1: Professional Learning'
      totalAmount={props.budgetSummary.priorityOneSummary.totalAmount}
      isdSummaries={props.budgetSummary.priorityOneSummary.isdSummaries.map(summary => ({
        isdName: summary.isdName,
        totalAmount: summary.totalAmount
      }))}
    />

    <PriorityBudgetDisplay
      title='Priority 2: Coaching Structure and Systems'
      totalAmount={props.budgetSummary.priorityTwoSummary.totalAmount}
      isdSummaries={props.budgetSummary.priorityTwoSummary.isdSummaries.map(summary => ({
        isdName: summary.isdName,
        totalAmount: summary.coachingStructure.amount
      }))}
    />

    <PriorityBudgetDisplay
      title='Priority 3: Coaching for Implementation of Evidence-based Practices'
      totalAmount={props.budgetSummary.priorityThreeSummary.totalAmount}
      isdSummaries={props.budgetSummary.priorityThreeSummary.isdSummaries.map(summary => ({
        isdName: summary.isdName,
        totalAmount: summary.classroomsAndFocusStudents.amount
      }))}
    />

    <PriorityBudgetDisplay
      title='Priority 4: Peer to Peer Programs'
      totalAmount={props.budgetSummary.priorityFourSummary.totalAmount}
      isdSummaries={props.budgetSummary.priorityFourSummary.isdSummaries.map(summary => ({
        isdName: summary.isdName,
        totalAmount: summary.totalAmount
      }))}
    />
  </Box>
}
